var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMute = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mute_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mute_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.176 6 6 8.178l6.73 6.733-.448.463H6.108v9.267h6.174L20 32.363V22.185l6.452 6.456c-1.003.757-2.13 1.359-3.365 1.714v3.182c2.069-.464 3.967-1.421 5.572-2.703L31.824 34 34 31.822 8.176 6Zm22.629 14.008c0 1.266-.232 2.486-.633 3.614l2.362 2.363a13.807 13.807 0 0 0 1.358-5.977c0-6.61-4.615-12.14-10.805-13.545v3.182c4.461 1.328 7.718 5.467 7.718 10.363ZM20 7.653l-2.902 2.903L20 13.46V7.652Zm6.946 12.355c0-2.734-1.574-5.081-3.859-6.224v2.764l3.828 3.83c.015-.123.031-.247.031-.37Z"
}))));
export default SvgMute;